export const tags = ['SOPInstanceUID', 'SOPClassUID'];
